import React from 'react'

interface StatusConfig {
  label: string
  className: string
}

const STATUS_MAP: Record<string, StatusConfig> = {
// ── RFQ statuses ──────────────────────────────────────────────────────────
'open':      { label: 'Awaiting Offers',  className: 'bg-blue-100 text-blue-800' },
'quoted':    { label: 'Quote Submitted',  className: 'bg-orange-100 text-orange-700' },
'closed':    { label: 'Closed',           className: 'bg-amber-100 text-amber-800' },
'settled':   { label: 'Settled ✓',        className: 'bg-green-100 text-green-800' },
'won':       { label: 'Won',              className: 'bg-green-100 text-green-800' },
'lost':      { label: 'Not allocated',          className: 'bg-gray-100 text-gray-400' },
'expired':   { label: 'Expired',          className: 'bg-gray-100 text-gray-400' },

// ── Provisioning leg statuses ─────────────────────────────────────────────
'started':         { label: 'Started',          className: 'bg-amber-100 text-amber-800' },
'in_progress':     { label: 'In Progress',      className: 'bg-blue-100 text-blue-800' },
'completed':       { label: 'Completed ✓',      className: 'bg-green-100 text-green-800' },
'failed':          { label: 'Failed',            className: 'bg-red-100 text-red-700' },

// ── Submission statuses ───────────────────────────────────────────────────
'submitted':       { label: 'Submitted',         className: 'bg-amber-100 text-amber-800' },
'documents_sent':  { label: 'Docs Sent',         className: 'bg-blue-100 text-blue-800' },
'acknowledged':    { label: 'Acknowledged',      className: 'bg-teal-100 text-teal-800' },
'declined':        { label: 'Declined',          className: 'bg-red-100 text-red-700' },
'ready':           { label: 'Ready ✓',           className: 'bg-green-100 text-green-800' },
'superseded':      { label: 'Superseded',        className: 'bg-gray-100 text-gray-400' },
}

interface Props { status: string }

export const Badge: React.FC<Props> = ({ status }) => {
  const config = STATUS_MAP[status] ?? { label: status, className: 'bg-gray-100 text-gray-600' }
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${config.className}`}>
      {config.label}
    </span>
  )
}